/* 合トレナビの訴求（ジム記事・snippets/fp-gotore.liquid）
   ・本文の下の枠／サイドバー：件数を my.fitpeak.co/api/gotore/public/gym から取って文言を差し替える（ログイン不要・名前は返ってこない）
   ・本文の中段のバナー：本文の真ん中に一番近い見出しの前（2026-10-19〜 全記事。テスト: scripts/test/gotore-mid.test.cjs）
   ・スマホの追従バー：30%スクロール後。×で7日間、押した人には30日間出さない
   件数が取れないときはサーバー描画の文言とボタンのまま残す。テスト: scripts/test/gotore.test.cjs */
(function () {
  var BASE = 'https://my.fitpeak.co';
  var SLOTS = { wd_am: '平日朝', wd_pm: '平日昼', wd_night: '平日夜', we_am: '土日朝', we_pm: '土日昼', we_night: '土日夜' };
  var PARTS = { chest: '胸', back: '背中', legs: '脚', shoulders: '肩', arms: '腕', full: '全身', cardio: '有酸素' };
  var LEVELS = { beginner: '初心者', intermediate: '中級者', advanced: '上級者', competitor: '大会出場' };

  function urls(key) {
    var top = BASE + '/my-fitpeak/gotore';
    if (!key) return { board: top, post: top, watch: top };
    var board = top + '/gym/' + encodeURIComponent(key);
    return { board: board, post: board + '?new=1', watch: board + '?watch=1' };
  }

  function label(list, map) {
    var out = [];
    for (var i = 0; i < (list || []).length; i++) if (map[list[i]]) out.push(map[list[i]]);
    return out.join('・');
  }

  // area: 地域別記事の市区町村名（店舗レビューは空＝「このジム」）
  // 2026-10-18〜 掲示板（募集）をやめ、同じ都道府県の人どうしのマッチングに。件数は出さず、文言は固定
  function view(d, area) {
    var where = area || 'このジム';
    return { headline: where + 'の近くで、一緒にトレーニングする仲間を探せます', sub: '', items: [], primary: '合トレ仲間を探す' };
  }

  window.fpGotore = { urls: urls, view: view };

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  function fill(el, v) {
    var q = function (s) { return el.querySelector(s); };
    var h = q('[data-gt-headline]'); if (h) h.textContent = v.headline;
    var s = q('[data-gt-sub]'); if (s) s.textContent = v.sub;
    var p = q('[data-gt-primary]');
    if (p) p.textContent = v.primary; /* 行き先は公式LINEの友だち追加のまま（fp-line.liquid のクリック処理） */
    var list = q('[data-gt-items]');
    if (list) {
      list.innerHTML = '';
      for (var i = 0; i < v.items.length; i++) {
        var li = document.createElement('li');
        li.textContent = v.items[i];
        list.appendChild(li);
      }
      list.hidden = !v.items.length;
    }
  }

  // 本文の中段（真ん中に一番近い見出しの前）に1つだけ入れる。2026-10-19〜 ジムナビの全記事
  //   見出しが横並びの枠・色付きの箱・表や箇条書きの中にあるときは、そのまとまりの外（前）に入れる
  //   使える見出しが無い記事は、本文のまとまり（段落・表など）の真ん中に近いものの前、それも無ければ本文の最後
  var NO_ENTER = /^(LI|UL|OL|DL|DT|DD|TABLE|THEAD|TBODY|TFOOT|TR|TD|TH|A|DETAILS|SUMMARY|FIGURE|BLOCKQUOTE|LABEL|BUTTON)$/;
  function flowBox(n, styleOf) {
    if (NO_ENTER.test(n.tagName || '')) return false;
    var st = styleOf(n) || {};
    var bg = st.backgroundColor || '';
    return (st.display === 'block' || st.display === 'flow-root') && (bg === '' || bg === 'transparent' || /^rgba\(0, 0, 0, 0\)$/.test(bg));
  }
  function anchor(el, root, styleOf) {
    var at = el;
    var cur = el;
    while (cur.parentNode && cur.parentNode !== root) {
      if (!flowBox(cur.parentNode, styleOf)) at = cur.parentNode;
      cur = cur.parentNode;
    }
    // 枠の先頭の見出しなら、枠のまとまりごと前に（例: 見出し枠＋一覧の .fsc-city）
    while (at.parentNode && at.parentNode !== root && at.parentNode.firstElementChild === at) at = at.parentNode;
    return at;
  }
  function pick(tops, total) {
    if (!total || !tops.length) return -1;
    var best = -1, gap = Infinity;
    for (var i = 0; i < tops.length; i++) {
      var r = tops[i] / total;
      if (r < 0.2 || r > 0.85) continue;
      var g = Math.abs(r - 0.5);
      if (g < gap) { gap = g; best = i; }
    }
    return best;
  }
  window.fpGotore.anchor = anchor;
  window.fpGotore.pick = pick;

  function placeMid() {
    var tpl = document.getElementById('fp-gotore-tpl-mid');
    var body = document.querySelector('.kt-article .kt-body');
    if (!tpl || !tpl.content || !body) return;
    if (body.querySelector('.fp-gotore-mid')) return;
    var styleOf = function (n) { return window.getComputedStyle(n); };
    var shown = function (n) { return n.getClientRects().length > 0; };
    var base = body.getBoundingClientRect().top;
    var total = body.getBoundingClientRect().height;
    var cands = [], tops = [];
    var add = function (n) {
      if (cands.indexOf(n) >= 0 || !shown(n)) return;
      cands.push(n);
      tops.push(n.getBoundingClientRect().top - base);
    };
    var hs = body.querySelectorAll('h2');
    for (var i = 0; i < hs.length; i++) if (shown(hs[i])) add(anchor(hs[i], body, styleOf));
    var k = pick(tops, total);
    if (k < 0) {
      // 見出しで決まらない記事: 本文を包むだけの枠（div.gr など）の中へ降りて、段落・表などのまとまりから選ぶ
      var box = body;
      var kids = function (b) {
        var out = [];
        for (var c = b.firstElementChild; c; c = c.nextElementSibling) {
          if (!/^(STYLE|SCRIPT|TEMPLATE|LINK|META|NOSCRIPT)$/.test(c.tagName) && shown(c)) out.push(c);
        }
        return out;
      };
      var list = kids(box);
      while (list.length === 1 && flowBox(list[0], styleOf)) { box = list[0]; list = kids(box); }
      cands = []; tops = [];
      for (var j = 0; j < list.length; j++) add(list[j]);
      k = pick(tops, total);
    }
    var frag = tpl.content.cloneNode(true);
    if (k >= 0) cands[k].parentNode.insertBefore(frag, cands[k]);
    else body.appendChild(frag);
  }

  function placeSticky() {
    if (!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '') || window.innerWidth >= 750) return;
    var now = Date.now();
    if (parseInt(store('fpgt_sticky_hide') || '0', 10) > now) return;
    var clicked = parseInt(store('fpgt_clicked') || '0', 10);
    if (clicked && now - clicked < 30 * 864e5) return;
    var tpl = document.getElementById('fp-gotore-tpl-sticky');
    if (!tpl || !tpl.content) return;
    document.body.appendChild(tpl.content.cloneNode(true));
    var bar = document.querySelector('.fp-gotore-sticky');
    if (!bar) return;
    function check() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || window.pageYOffset || 0;
      if (y > 600 || (max > 0 && y / max >= 0.3)) {
        bar.classList.add('is-on');
        window.removeEventListener('scroll', check);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    bar.querySelector('.fp-gotore-sticky__x').addEventListener('click', function () {
      bar.classList.remove('is-on');
      store('fpgt_sticky_hide', String(Date.now() + 7 * 864e5));
    });
    bar.querySelector('.fp-gotore-sticky__btn').addEventListener('click', function () {
      store('fpgt_clicked', String(Date.now()));
    });
  }

  function init() {
    var els = document.querySelectorAll('[data-fp-gotore]');
    if (!els.length) return;
    var key = els[0].getAttribute('data-key') || '';
    var area = els[0].getAttribute('data-area') || '';
    placeMid();
    placeSticky();
    if (!key) return;
    fetch(BASE + '/api/gotore/public/gym?handle=' + encodeURIComponent(key))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        var v = view(d, area);
        for (var i = 0; i < els.length; i++) fill(els[i], v);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
